var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-5"},[_vm._m(0),_c('div',{staticClass:"row pt-5"},[_c('div',{staticClass:"col-md-4 offset-md-4 col-sm-12"},[_c('Login')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":"/img/logo-preta.png","width":"200","alt":"Logo Bike Registrada"}})])
}]

export { render, staticRenderFns }